export default {
    HEADER: 'WEBSITE',
    PLACEHOLDER_NAME: 'Enter website name',
    LABEL_NAME: 'Name',
    PLACEHOLDER_DOMAIN: 'Enter website domain',
    LABEL_DOMAIN: 'Domain',
    LABEL_COMPANY: 'Company',
    LABEL_HOME_TYPE: 'Home type',
    LABEL_MENU_TYPE: 'Menu type',
    LABEL_ARTICLE_TYPE: 'Article type',
    LABEL_DESCRIPTION: 'Description',
    PLACEHOLDER_DESCRIPTION: 'Enter website description',
    CANCEL: 'Cancel',
    SUBMIT: 'Submit',
};
